export enum ICON_TYPE {
  BACK_ARROW
}

export type IconInfo = {
  iconUrl?: string | ICON_TYPE
  text?: string
  callback?: () => void
}
export type TitleBarOptionsType = {
  hideNativeBar?: boolean
  isImmersive?: boolean // false非沉浸式：从状态栏顶部开始布局+不透明；true沉浸式：则改成从手机顶开始布局+标题栏透明+状态栏透明+标题栏扩张高度+标题栏浮动。
  theme: 'auto' | 'light' | 'dark' // 状态栏和标题栏和webview主题，auto跟随系统，light浅色，dark深色。
  // 以下是前端标题栏样式配置：
  titleBar: {
    isHidden?: boolean // 是否隐藏标题栏，隐藏后则需页面 view 视图自己实现。
    isTransparent?: boolean
    left?: Array<IconInfo>
    center?: string
    right?: Array<IconInfo>
    scrollBgColor?: string | 'auto' | 'no' // string是自定义设置滚动时背景颜色，auto表示自动使用主题色。no是不要滚动变色。
  }
  statusBar?: {
    isHidden?: boolean | undefined
  }
}
